import { render, staticRenderFns } from "./BaseCardUploadProofOrigin.vue?vue&type=template&id=d6334bde&scoped=true&"
import script from "./BaseCardUploadProofOrigin.vue?vue&type=script&lang=js&"
export * from "./BaseCardUploadProofOrigin.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardUploadProofOrigin.vue?vue&type=style&index=0&id=d6334bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6334bde",
  null
  
)

export default component.exports